<template>
  <div v-if="id">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <div class="row mb-1 d-flex align-items-center">
            <div class="col-md-4">
              <div v-if="!cal_view" class="form-group">
                <label for="mois">Mois </label>
                <date-picker
                  v-model="date"
                  type="month"
                  name="mois"
                  placeholder="Tous les mois"
                  lang="fr"
                  format="MM/YYYY"
                  value-type="MM/YYYY"
                  @input="onMonthSelect"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-8 text-right">
              <button
                type="button"
                class="btn btn-custom-primary ml-2"
                @click.prevent="cal_view = !cal_view"
              >
                <span v-if="cal_view"
                  ><i class="fas fa-list"></i> List View</span
                >
                <span v-else
                  ><i class="fas fa-calendar"></i> Calendar View</span
                >
              </button>

              <button
                type="button"
                class="btn btn-danger ml-4"
                @click.prevent="deleteAllSelectionEchange"
                v-show="isSelectEchange"
              >
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
            </div>
          </div>
          <h5 v-if="!cal_view" class="text-center mb-4">
            <span v-if="this.date"
              ><i class="fa fa-calendar text-custom-primary mr-2"></i> Planning
              du mois de: {{ this.date }}</span
            >
            <span v-else
              ><i class="fa fa-calendar text-custom-primary mr-2"></i>Planning
              (Tous les mois)</span
            >
          </h5>
          <div class="row">
            <div class="col-md-12">
              <DataTable v-show="!cal_view" :id="id" ref="datatableEchange" />
              <Calendar :id="id" v-show="cal_view" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import Calendar from '../components/Calendar.vue';
import names from '@/constants/routes/chantier/planning';
import DatePicker from 'vue2-datepicker';

export default {
  data() {
    return {
      cal_view: false,
      isSelectEchange: false,
      id: null,
      routes: names,
      date: this.$options.filters.formatDate(new Date(), 'MM/YYYY'),
    };
  },
  components: {
    DataTable,
    DatePicker,
    Calendar,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    init() {
      this.id = Number(this.$route.params.id);
    },
    onMonthSelect() {
      this.$refs.datatableEchange.setMonthAndLoad(this.date);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
